<script>
	import Layout from "../../layouts/main";
	import PageHeader from "../../components/page-header";
	import { IncentiveService, bannerService } from "../../services";
	import { success_message, error_message } from "../../Helper/helper";
	import { required, numeric } from "vuelidate/lib/validators";
	import Multiselect from "vue-multiselect";
	import DatePicker from "vue2-datepicker";
	import "vue2-datepicker/index.css";
	import Swal from "sweetalert2";
	import config from '../../config';

	export default {
		props: {
			is_mextra_incentive : Boolean,
			restaurantData : {
				type: [Object, Array],
				required: true
			},
		},
		components: { Layout, PageHeader, Multiselect, DatePicker },
		data() {
			return {
				config: config,
				typeform: {
					checked: false,	
					selectedRestaurant : [],
				},
				extra_incentives: [
					{ date_range: ['', ''], amount: null }
				],
				restaurants: [],
				isLoading: false,
				showTimeRangePanel: false,
				rangeSeparator: "-",
			}
		},
		validations: {
			typeform: {
				selectedRestaurant: {
					required,
				}
			},
			extra_incentives: {
				$each: {
					date_range: {
						0: { required },
						1: { required },
					},
					amount: { required },
				}
			},
		},
		mounted() {
			this.asyncFind();
		},
		watch: {
			restaurantData: {
				immediate: true,
					handler(newVal) {	
					if(!this.is_mextra_incentive)
					{
						if (newVal && Object.keys(newVal).length) {
							this.initData(newVal); 
							this.fetchIncentives();
						}
					}
				}
			}
		},
		methods: {
			initData(data) {
				this.typeform.selectedRestaurant = Array.isArray(data) ? data : [data];
			},
			async asyncFind(query) {
				this.isLoading = true;
				try {
					const response = await bannerService.getRestaurant(query);
					this.restaurants = response.data.result;
				} catch (error) {
					console.error("Failed to fetch restaurants:", error);
					error_message("Could not load restaurants.");
				} finally {
					this.isLoading = false;
				}
			},
			clearAll() {
				this.typeform.selectedRestaurant = [];
			},
			toggleTimeRangePanel() {
				this.showTimeRangePanel = !this.showTimeRangePanel;
			},
			handleRangeClose() {
				this.showTimeRangePanel = false;
			},
			disabledBeforeTodayAndAfterAWeek(date) {
				return date < new Date(new Date().setHours(0, 0, 0, 0));
			},
			addRow() {
				this.extra_incentives.push({ date_range: ['', ''], amount: null });
			},
			removeRow(index, id) {
				if (!id) {
					this.extra_incentives.splice(index, 1);
				}
				else
				{
					const restaurantIds = this.typeform.selectedRestaurant.map(r => r.restaurant_id);
					IncentiveService.removeIncentive({ restaurantId: restaurantIds, id: id })
						.then((response) => {
							console.log(response);
							
							if (response.data.code === 200) {
								this.extra_incentives.splice(index, 1);
								success_message(response.data.message || 'Incentive deleted successfully!');
							} else {
								error_message(response.data.message || 'Failed to delete incentive.');
							}
						})
						.catch((error) => {
							console.error('Failed to delete incentive:', error);
							error_message('Failed to delete incentive.');
						});
				}

			},
			disabledDate(date, currentItem) {
				const now = new Date();
				const oneWeekLater = new Date();
				const currentTimestamp = date.getTime();

				// Disable if before today or after 7 days
				if (currentTimestamp < now.getTime()) {
					return true;
				}

				return this.extra_incentives.some(item => {
					if (!item.date_range || item === currentItem) return false;

					const [startStr, endStr] = item.date_range;
					if (!startStr || !endStr) return false;

					const startTimestamp = new Date(startStr).getTime();
					const endTimestamp = new Date(endStr).getTime();

					// ❌ Don't allow overlap
					return currentTimestamp >= startTimestamp && currentTimestamp <= endTimestamp;
				});
			},
			disabledTime(date, currentItem) {
				const timestamp = date.getTime();

				// Prevent selecting same start & end time
				if (currentItem?.date_range?.[0] && new Date(currentItem.date_range[0]).getTime() === timestamp) {
					return true;
				}

				return this.extra_incentives.some(item => {
					if (!item.date_range || item === currentItem) return false;

					const [startStr, endStr] = item.date_range;
					const startTime = new Date(startStr).getTime();
					const endTime = new Date(endStr).getTime();

					// ❌ Overlap check
					return timestamp >= startTime && timestamp <= endTime;
				});
			},
			async storeIncentives() {
				this.$v.$touch();
				if (this.$v.typeform.$invalid) {
					return;
				}

				this.$v.extra_incentives.$touch();
				if (this.$v.extra_incentives.$invalid) {
					return;
				}
				
				console.log(this.extra_incentives);
				
				const restaurantIds = this.typeform.selectedRestaurant.map(r => r.restaurant_id);
				const incentives = this.extra_incentives.filter(item => item.amount && item.date_range[0] && item.date_range[1]);

				if (incentives.length === 0) {
					return;
				}

				try 
				{
					console.log(incentives);
					
					const response = await IncentiveService.storeExtraIncentives({
						restaurant_ids: restaurantIds,
						incentives: incentives
					});
					
					success_message(response.data.message || 'Incentives saved successfully!');
					if(this.is_mextra_incentive)
					{
						this.typeform.selectedRestaurant = [];
						this.extra_incentives = [{ date_range: ['', ''], amount: null }];
						this.$v.$reset();
					}
					else
					{
						this.fetchIncentives();
					}
				} catch (error) {
					if (error.response) {
						error_message(error.response)
					} else {
						console.error('Failed to store extra incentives:', error);
						error_message('Failed to store extra incentives.');
					}
				}
			},
			deleteAllIncentives() {
				this.$v.typeform.selectedRestaurant.$touch();
				if (this.$v.typeform.selectedRestaurant.$invalid) {
					return;
				}

				Swal.fire({
					title: 'Are you sure you want to delete all incentives for the selected restaurant(s)?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#34c38f',
					cancelButtonColor: '#f46a6a',
					confirmButtonText: 'Yes'
				}).then(async (result) => {
					if (result.isConfirmed) {
						const restaurantIds = this.typeform.selectedRestaurant.map(r => r.restaurant_id);

						try {
							const response = await IncentiveService.removeAllIncentives({
								restaurant_ids: restaurantIds,
							});
							
							this.typeform.selectedRestaurant = [];
							this.$v.$reset();
							success_message( response.data.message || 'Incentives deleted successfully!');
						} catch (error) {
							if (error.response) {
								error_message(error.response)
							} else {
								console.error('Failed to delete all incentives:', error);
								error_message('Failed to delete all incentives.');
							}
						}
					}
				});
			},
			fetchIncentives() {
				try 
				{
					const restaurant_id = Array.isArray(this.restaurantData)
						? this.restaurantData.map(r => r.restaurant_id)
						: [this.restaurantData.restaurant_id];

					IncentiveService.fetchIncentives({
						restaurant_id: restaurant_id,
					})
					.then((response) => {
						const data = response.data.result || []; // If data is not found, use an empty array
						if(data && data.length > 0)
						{
							this.extra_incentives = data.map(item => ({
								id: item.id,
								amount: item.amount,
								date_range: [
									item.date_range[0],
									item.date_range[1]
								],
							}));
						}
						else
						{
							this.extra_incentives = [{ date_range: ['', ''], amount: null }];
						}
					})
					.catch((error) => {
						console.error('Error fetching incentives:', error);
						error_message('Failed to fetch incentives.');
					});

				} catch (error) {
					console.error('Error fetching incentives:', error);
					error_message('Failed to fetch incentives.');
				}
			},
		},
		filters: {
			date(val) {
				return val ? val.toLocaleString() : "";
			},
		},
	}

</script>

<template>
	<div>
		<div class="row" v-if="is_mextra_incentive">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
					<div class="page-title-left">
						<div class="avatar-xs mr-3">
						<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
							<i class="bx bx-user-circle"></i>
						</span>
						</div>
						<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Manage Extra Incentives') }}</h4>
					</div>
					<div class="page-title-right">
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<div class="card" v-if="is_mextra_incentive">
					<div class="card-body">
						<div class="row mb-2">
							<div class="col-md-9">
								<div class="form-group mb-0">
									<label class="control-label">{{ trans.get('__JSON__.Select Restaurants') }}</label>
									<div class="search-box mr-2 d-inline-block w-100">
										<div class="position-relative">
											<multiselect
												v-model="$v.typeform.selectedRestaurant.$model"
												id="ajax"
												v-bind:disabled="typeform.checkbox"
												label="name"
												track-by="name"
												:placeholder="
													trans.trans('__JSON__.Vendor Search', {
													vendor: $auth.setting.restaurant_name,
													})
												"
												:loading="isLoading"
												open-direction="bottom"
												:options="restaurants"
												:multiple="true"
												:searchable="true"
												:internal-search="true"
												:clear-on-select="false"
												:close-on-select="false"
												:options-limit="30"
												:limit="100"
												:max-height="600"
												:show-no-results="false"
												:hide-selected="true"
												:class="{
													'is-invalid': $v.typeform.selectedRestaurant.$error,
												}"
											>
											<template slot="tag" slot-scope="{ option, remove }">
												<span class="custom__tag">
												<span>{{ option.name }}</span>
												<span class="custom__remove" @click="remove(option)">❌</span>
												</span>
											</template>
											<template slot="clear" slot-scope="props">
												<div class="multiselect__clear"
												v-if="typeform.selectedRestaurant.length"
												@mousedown.prevent.stop="clearAll(props.search)"
												></div>
											</template>
											<template slot="noOptions">
												<span>{{ trans.get("__JSON__.Search...") }}.</span>
											</template>
											<template slot="noResult">
												<span
												>{{
													trans.get(
													"__JSON__.Oops! No elements found. Consider changing the search query"
													)
												}}.</span
												>
											</template>
											</multiselect>
											<div
												v-if="$v.typeform.selectedRestaurant.$error"
												class="invalid-feedback"
												>
													<span v-if="!$v.typeform.selectedRestaurant.required"
													>{{
													trans.get("__JSON__.Vendor Select Error", {
														vendor: $auth.setting.restaurant_name,
													})
													}}.</span
												>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-3">
								<div class="form-group">
									<label class="control-label"></label>
									<div>
										<b-button class="ml-2"variant="danger" :placeholder="trans.get('__JSON__.Click to remove all incentives of selected restaurant')" @click.prevent="deleteAllIncentives"  v-if="$auth.hasPermission(config.permissions.manage_extra_incentives_write)">{{ trans.get('__JSON__.Remove All Incentives') }}</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-body">
						<h4 class="card-title" v-if= "is_mextra_incentive">{{ trans.get('__JSON__.Add Extra Incentives') }}</h4>
						<h4 class="card-title" v-else>{{ trans.get('__JSON__.Add/Update Extra Incentives') }}</h4>
						<div class="row mt-4">
							<div class="col-sm-6">
								<div class="form-group">
									<div class="row" v-for="(extra_incentive, index) in $v.extra_incentives.$each.$iter" :key="index">
										<div class="col-md-6">
												<div class="form-group">
												<label class="control-label" v-if="index == 0">{{ trans.get('__JSON__.Start/End Period') }}</label>
												<!-- :disabled-time="disabledTime" -->
												<date-picker
													v-model="extra_incentive.date_range.$model"
													value-type="format"
													:disabled-date="disabledBeforeTodayAndAfterAWeek"
													:placeholder="trans.get('__JSON__.Start/End Period')"
													:rangeSeparator="rangeSeparator"
													type="datetime"
													range
													:show-time-panel="showTimeRangePanel"
													@close="handleRangeClose"
													:class="{ 'is-invalid': extra_incentive.date_range[0].$error || extra_incentive.date_range[1].$error }"
												>
													<template v-slot:footer>
														<button class="mx-btn mx-btn-text" @click="toggleTimeRangePanel">
															{{ showTimeRangePanel ? 'select date' : 'select time' }}
														</button>
													</template>
												
												</date-picker>	
												<div v-if="extra_incentive.date_range[0].$error || extra_incentive.date_range[1].$error" class="invalid-feedback d-block">
													<span v-if="!extra_incentive.date_range[0].required || !extra_incentive.date_range[1].required">
														{{ trans.get('__JSON__.Please enter start and end period') }}
													</span>
												</div>
											</div>
										</div>
										<div class="col-md-2">
											<div class="form-group">
												<label class="control-label" v-if="index == 0">{{ trans.get('__JSON__.Incentive') }}</label>
												<input type="number" :placeholder="trans.get('__JSON__.Incentive')" v-model="extra_incentive.amount.$model" class="form-control w-20" :class="{ 'is-invalid': extra_incentive.amount.$error }" />

												<div v-if="extra_incentive.amount.$error" class="invalid-feedback">
													<span v-if="!extra_incentive.amount.required">{{ trans.get('__JSON__.Please enter amount') }}</span>
													<!-- <span v-if="!extra_incentive.amount.numeric">{{ trans.get('__JSON__.Amount must be numeric') }}</span> -->
												</div>
											</div>
										</div>
										<div class="col-md-2" v-if="$auth.hasPermission(config.permissions.manage_extra_incentives_write)">
											<h6 v-if="index == 0">&nbsp;</h6>
											<button class="btn btn-primary btn-sm btn-rounded" :placeholder="trans.get('__JSON__.Click to add incentive')" @click.prevent="addRow">+</button>
											<button class="btn btn-danger btn-sm btn-rounded ml-2" :placeholder="trans.get('__JSON__.Click to remove incentive')" @click.prevent="removeRow(index, extra_incentive.$model.id || null)" v-if="index > 0">-</button>
										</div>
									</div>
								</div>
								<div>
									<b-button variant="primary" @click="storeIncentives" v-if="$auth.hasPermission(config.permissions.manage_extra_incentives_write)">
										<span>
											{{ trans.get('__JSON__.Save') }}
										</span>
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>